import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { initialState } from './reducer';
import { State } from './types';

const selectState = (state: RootState) => state.informes || initialState;

// Informes horas
export const makeSelectInformesHoras = () =>
  createSelector(selectState, (state: State): any[] => state.informesHoras);

export const makeSelectInformesHorasCount = () =>
  createSelector(
    selectState,
    (state: State): number => state.informesHorasCount
  );

// Informes horas Instructor
export const makeSelectInformesHorasInstructor = () =>
  createSelector(
    selectState,
    (state: State): any[] => state.informesHorasInstructor
  );

export const makeSelectInformesHorasInstructorCount = () =>
  createSelector(
    selectState,
    (state: State): number => state.informesHorasInstructorCount
  );

// Informes infraestructura
export const makeSelectInformesInfraestructura = () =>
  createSelector(
    selectState,
    (state: State): any[] => state.informesInfraestructura
  );

export const makeSelectInformesInfraestructuraCount = () =>
  createSelector(
    selectState,
    (state: State): number => state.informesInfraestructuraCount
  );

// Filtros
export const makeSelectSociedadesInformesParsed = () =>
  createSelector(selectState, (state: State): string => {
    const sociedadesdesParsed = state.sociedades.map((sociedad) => ({
      label: sociedad.ID_SOCIEDAD + ' - ' + sociedad.NOMBRE_SOCIEDAD,
      value: sociedad.ID_SOCIEDAD,
    }));

    return JSON.stringify(sociedadesdesParsed);
  });

export const makeSelectProvinciasInformesParsed = () =>
  createSelector(selectState, (state: State): string => {
    const provinciasParsed = state.provincias.map((provincia) => ({
      label: provincia,
      value: provincia,
    }));

    return JSON.stringify(provinciasParsed);
  });

export const makeSelectEstadosInformesParsed = () =>
  createSelector(selectState, (state: State): string => {
    const estadosParsed = state.estados.map((estado) => ({
      label: estado.DESC_ESTADO,
      value: estado.ID_ESTADO,
    }));

    return JSON.stringify(estadosParsed);
  });

export const makeSelectCursosInformesParsed = () =>
  createSelector(selectState, (state: State): string => {
    const cursosParsed = state.cursosFilter.map((curso) => ({
      label: curso.ID_CURSO + ' - ' + curso.NOMBRE_CURSO,
      value: curso.ID_CURSO,
    }));

    return JSON.stringify(cursosParsed);
  });

export const makeSelectAlumnosInformesParsed = () =>
  createSelector(selectState, (state: State): string => {
    const alumnosParsed = state.alumnos.map((alumno) => ({
      label: alumno.ID_ALUMNO + ' - ' + alumno.NOMBRE_ALUMNO,
      value: alumno.ID_ALUMNO,
    }));

    return JSON.stringify(alumnosParsed);
  });

// Cache
export const makeSelectAllInformesCursosFilter = () =>
  createSelector(selectState, (state: State): any[] => state.allCursosFilter);
